import { graphql } from "src/graphql/generated";

export const createAPIKeyMutation = graphql(/* GraphQL */ `
    mutation CreateAPIKey($clientId: String!, $name: String!, $expiresAt: Float) {
        createAPIKey(clientId: $clientId, name: $name, expiresAt: $expiresAt) {
            ...apiKeyFields
        }
    }
`);

export const deleteAPIKeyMutation = graphql(/* GraphQL */ `
    mutation DeleteAPIKey($clientId: String!, $apiKeyId: String!) {
        deleteAPIKey(clientId: $clientId, apiKeyId: $apiKeyId) {
            ...apiKeyFields
        }
    }
`);
